import { forEach } from 'lodash';

import configuration from 'configs/configuration';
import { ILoginModelRegistrationApi } from 'modules/account/features/login/models';
import API from 'services/api';

export const confirmUserRegistration = (token: string) =>
  API.patch(`api/customers/signup/${token}/confirm`);

interface IProps {
  values: ILoginModelRegistrationApi;
  formik: any; // TODO this needs to be FormikHelper
}

//login
export const login = ({ values: { username, password } }: IProps) => {
  const loginInfo = {
    grant_type: 'password',
    username: username,
    password: password,
    client_id: configuration.clientId,
    client_secret: configuration.clientSecret,
  };

  const formData = new FormData();
  forEach(loginInfo, (value, key) => {
    if (value !== undefined) {
      formData.append(key, value);
    }
  });

  return API.post('/connect/token', formData, {
    headers: {
      'Content-Type': 'multipart/form-data;',
    },
  });
};
